export enum DashboardActionType {
  OpenDashboard = 'open-dashboard',
  OpenDashboardByDevCenterCompId = 'open-sh-dp',
}

export function parseBlocksDashboardAction(
  id: string,
  actionType: DashboardActionType,
) {
  const regex = new RegExp(`^${actionType}: <(.+)>$`);
  const match = regex.exec(id);

  if (!match) {
    return undefined;
  }

  let dashboardId = match[1];

  if (dashboardId.startsWith('#')) {
    dashboardId = dashboardId.substring(1);
  }

  return { dashboardId, actionType };
}
